import { useEffect, useState } from "react";
import "./transition.scss";

export default function Transition(props: {
  children?: any;
  index: number;
  className?: string;
  isFadeOut?: boolean;
}) {
  const [index, setIndex] = useState(props.index);

  useEffect(() => {
    if (props.index) setTimeout(() => setIndex(index + 1), 2000);
  }, [props.index]);

  return (
    <>
      {props.children.map((e: any, i: number) => (
        <div
          key={i}
          className={[
            props.className,
            props.index == i + 1
              ? props.isFadeOut
                ? "fade-out"
                : "disappeared"
              : props.index == i
              ? "fade-in"
              : "hide",
          ].join(" ")}
          style={{
            display:
              props.index == i && props.index - index == 1
                ? ""
                : index >= i
                ? ""
                : "none",
          }}
        >
          {e}
        </div>
      ))}
    </>
  );
}
